/* Braymont USA — one true campaign deadline across announcement bar and product bundles.
   When time expires only timer UI is hidden. Discounts and products are NEVER changed. */
(function(){
  "use strict";
  if(window.__BraymontBlackFridayTimerLoaded)return;
  window.__BraymontBlackFridayTimerLoaded=true;
  const rotations=new WeakMap();
  const deadlines=new WeakMap();
  function expiry(date,time,zone){
    if(!/^\d{4}-\d{2}-\d{2}$/.test(date||"")||!/^\d{2}:\d{2}$/.test(time||""))return NaN;
    const [y,mo,d]=date.split("-").map(Number),[h,mi]=time.split(":").map(Number);
    if(mo<1||mo>12||d<1||d>31||h>23||mi>59)return NaN;
    const wanted=Date.UTC(y,mo-1,d,h,mi,0);
    const zoneName=zone||"America/New_York";
    const formatter=new Intl.DateTimeFormat("en-US",{timeZone:zoneName,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",hourCycle:"h23"});
    let resolved=wanted;
    for(let i=0;i<4;i++){
      const pieces=Object.fromEntries(formatter.formatToParts(new Date(resolved)).filter(x=>x.type!=="literal").map(x=>[x.type,Number(x.value)]));
      const wall=Date.UTC(pieces.year,pieces.month-1,pieces.day,pieces.hour,pieces.minute,pieces.second);
      const difference=wanted-wall;
      if(difference===0)break;
      resolved+=difference;
    }
    return resolved;
  }
  function formatDigits(num){return String(num).padStart(2,"0");}
  function tick(){
    const nodes=document.querySelectorAll("[data-brm-bf-countdown]");
    const now=Date.now();
    for(const el of nodes){
      if(el.hidden)continue;
      let target=deadlines.get(el);
      if(target===undefined){
        try{target=expiry(el.dataset.brmBfDate,el.dataset.brmBfTime,el.dataset.brmBfTimezone);}
        catch(err){console.warn("[Braymont Black Friday] invalid timezone or date",err);target=NaN;}
        deadlines.set(el,target);
      }
      if(!Number.isFinite(target)){el.hidden=true;continue;}
      const sec=Math.max(0,Math.ceil((target-now)/1000));
      if(sec<=0){
        // Campaign is still managed manually in Shopify; hide ONLY the timer.
        el.hidden=true;
        const productCard=el.closest("[data-brm-bf-product]");
        if(productCard)productCard.hidden=true;
        continue;
      }
      const hours=Math.floor(sec/3600),mins=Math.floor(sec%3600/60),seconds=sec%60;
      const clock=el.querySelector("[data-brm-bf-clock]");
      if(clock)clock.textContent=formatDigits(hours)+":"+formatDigits(mins)+":"+formatDigits(seconds);
      const h=el.querySelector("[data-brm-bf-hours]");
      if(h)h.textContent=formatDigits(hours);
      const m=el.querySelector("[data-brm-bf-minutes]");
      if(m)m.textContent=formatDigits(mins);
      const s=el.querySelector("[data-brm-bf-seconds]");
      if(s)s.textContent=formatDigits(seconds);
    }
  }
  function initSlides(){
    for(const wrap of document.querySelectorAll("[data-brm-bf-rotate]")){
      if(rotations.has(wrap))continue;
      const slides=[...wrap.querySelectorAll("[data-brm-bf-slide]")];
      if(slides.length<2)continue;
      const seconds=Math.max(3,Math.min(10,Number(wrap.dataset.brmBfInterval)||5));
      let active=0;
      const interval=setInterval(()=>{
        if(!wrap.isConnected){clearInterval(interval);return;}
        const editorBlock=document.activeElement?.closest?.("[data-shopify-editor-block]");
        if(editorBlock&&wrap.contains(editorBlock))return;
        active=(active+1)%slides.length;
        slides.forEach((slide,index)=>{slide.hidden=index!==active;});
      },seconds*1000);
      rotations.set(wrap,interval);
    }
  }
  function initialize(){
    initSlides();tick();
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initialize,{once:true});
  else initialize();
  setInterval(tick,1000);
  document.addEventListener("visibilitychange",()=>{if(!document.hidden)tick();});
  document.addEventListener("shopify:section:load",initialize);
})();
